<template>
  <div class="UpdateClient" id="entete">
    {{ this.getClientToEdit }}
    <div class="rowCount">
      <button class="btn_update" @click="showCommentaire = !showCommentaire">
        Commentaires
      </button>
    </div>
    <div class="rowCount">
      <div
        :class="{
          BoxCommentaire: this.showCommentaire === true,
          desactive: this.showCommentaire === false,
        }"
      >
        <span>Commentaire</span>
        <div class="comment">
          <textarea
            v-model="commentaire"
            name="w3review"
            rows="2"
            cols="25"
            placeholder="Nouveau commentaire ..."
          />
          <button class="btn" @click="NewComment">Enregistrer</button>
        </div>
      </div>
    </div>
    <div class="rowCount" >
      <button class="btn_update" @click="showAnalyse = !showAnalyse">
        Analyse patrimoniale
      </button>
    </div>
    <div class="rowCount">
      <div
        :class="{
          BoxAnalyse: this.showAnalyse === true,
          desactive: this.showAnalyse === false,
        }"
      >
        <div class="rowA">
          <div class="col">
            <div class="colC">
              <div class="TypeContent">
                <Select
                  v-model="Client.iteamSelected"
                  description="Nom*"
                  :options="iteamSelect"
                  label="nom"
                />
              </div>
              <div class="Nomcontent">
                <Input
                  v-model="Client.first_name"
                  datatype="text"
                  placeholder="Nom"
                  description=""
                />
              </div>
            </div>
          </div>
          <div class="col">
            <Input
              v-model="Client.last_name"
              datatype="text"
              placeholder="Prénom"
              description="Prénom*"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <Input
              v-model="Client.tel"
              datatype="tel"
              placeholder="Téléphone"
              description="Téléphone"
            />
          </div>
          <div class="col">
            <Input
              v-model="Client.email"
              datatype="email"
              placeholder="Mail"
              description="Mail*"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <Input
              v-model="Client.tel"
              datatype="date"
              description="Date de naissance"
            />
          </div>
          <div class="col">
            <Select
              v-model="Client.handicape"
              description="Adulte handicapé ?"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <div class="Inline">
              <span>Adresse</span>
              <textarea
                v-model="Client.adresse"
                name="w3review"
                rows="2"
                cols="45"
                placeholder="Adresse"
              />
            </div>
          </div>
          <div class="col1">
            <Select
              v-model="Client.statut"
              description="Status"
              :options="iteamstatut"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col3">
            <Input
              v-model="Client.zipCode"
              datatype="number"
              placeholder="Code Postal"
              description="Code Postal"
            />
          </div>
          <div class="col3">
            <Input
              v-model="Client.ville"
              datatype="text"
              placeholder="Ville"
              description="Ville"
            />
          </div>
          <div class="col3">
            <Input
              v-model="Client.mobile"
              datatype="tel"
              placeholder="Mobile"
              description="Mobile"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
              <Select
              v-model="Client.situation"
              description="Situation maritale"
              :options="iteamsituation"
              label="nom"
            />
          </div>
          <div class="col1">
              <Select
              v-model="Client.conjoint"
              description="Conjoint"
              :options="iteamconjoint"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col0">
              <Select
              v-model="nb_enfant"
              description="Enfants à charge"
              :options="iteamEnfant"
              label="nom" @change="NewEnfant"
            />
          </div>
        </div>
        <div class="rowA" v-for="(iteam,i) in Client.nb_enfants" :key="i">
          <div class="col3">
            <Input
              v-model="iteam.date_naissance"
              datatype="date"
              placeholder="Date de naissance"
              description="Date de naissance"
            />
          </div>
          <div class="col3">
            <Select
              v-model="iteam.garde"
              description="Garde alternée?"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
          <div class="col3">
            <Select
              v-model="iteam.handicape"
              description="Adulte handicapé ?"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA">
            <div class="BoxSousTitre"><span class="sous_titre">Situation économique</span></div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Revenus mensuels nets*</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Revenus Locatifs mensuels actuels</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Autres revenus du foyer</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Statut professionnel</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="StatutPro"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Employeur</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Année de dbut d'activité</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Impots annuels*</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Crédit d'impot déjà utilise / an (emploi salarité à domicile ou autre)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">TMI</span></div>
          <div class="col">
            <Input
              :readonly='true'
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Statut hébergement</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="StatutHeberg"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Loyer mensuel payé (qui restera à payer post investissement)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Mensualités de crédits en cours</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Autres dépenses mensuelles(pensions,etc.)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Dépenses mensuelles courantes(= votre budget hors prets, loyer et impots)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Epargne mensuelle de précaution souhaitée</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Capacité d'épargne mensuelle</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
              :readonly='true'
            />
          </div>
        </div>
        <div class="rowA">
            <div class="BoxSousTitre"><span class="sous_titre">Patrimoine actuel</span></div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Immobilier : résidence principale</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Liquidités</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Titres et obligations</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Immobilier d'investissement</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA">
            <div class="BoxSousTitre"><span class="sous_titre">Objectifs partrimoniaux</span></div>
        </div>
        <div class="rowA dispal_block">
          <div><input type="checkbox" v-model="Client.name"  id="check1"/><label for="check1" class="checktitre">Constituer des revenus complémentaires pour votre retraite</label>
          </div>
          <div><input type="checkbox" v-model="Client.name"  id="check2"/><label for="check2" class="checktitre">Réduire vos impots</label>
          </div>
          <div>
          <input type="checkbox" v-model="Client.name"  id="check3"/><label for="check3" class="checktitre">Diminuer la fiscalité de vos revenus locatifs</label>
          </div>
          <div>
          <input type="checkbox" v-model="Client.name"  id="check4"/><label for="check4" class="checktitre">Aider vos enfants, petits-enfants ou vos parents</label>
          </div>
          <div>
          <input type="checkbox" v-model="Client.name"  id="check5"/><label for="check5" class="checktitre">Se constituer un patrimoine</label>
          </div>
          <div>
          <input type="checkbox" v-model="Client.name"  id="check6"/><label for="check6" class="checktitre">Autre</label>
          </div>
        </div>
        <div class="rowA">
            <div class="BoxSousTitre"><span class="sous_titre">Objectifs Immobiliers</span></div>
        </div>
        <div class="rowA">
          <div class="col">
            <Select
              v-model="Client.name"
              :options="Critere"
              label="nom"
              description="Critère 1"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <Select
              v-model="Client.name"
              :options="Critere"
              label="nom"
              description="Critère 2"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <Select
              v-model="Client.name"
              :options="Critere"
              label="nom"
              description="Critère 3"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <Select
              v-model="Client.name"
              :options="Critere"
              label="nom"
              description="Critère 4"
            />
          </div>
        </div>
        <div class="rowA">
          <div class="col">
            <Select
              v-model="Client.name"
              :options="Critere"
              label="nom"
              description="Critère 5"
            />
          </div>
        </div>
        <div class="rowA">
             <div class="arrow"> 
               <a href="#entete"><fa-icon :icon="{ prefix: 'fas', iconName: 'arrow-alt-circle-up'}" /></a>
             </div>
        </div>
      </div>
    </div>
    <div class="rowCount">
      <button class="btn_update" @click="showHybothese = !showHybothese">
        Hypothèses d'investissement
      </button>
    </div>
    <div class="rowCount">
      <div
        :class="{
          BoxAnalyse: this.showHybothese === true,
          desactive: this.showHybothese === false,
        }"
      >
      <div class="rowA"> 
          <div class="colSpan"><span class="span">Type de projet envisagé</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
      </div>
      <div class="rowA"> 
          <div class="colSpan"><span class="span">Prix TTC de l'investissement</span></div>
          <div class="col-2">
            <div class="col2_block">
               <Input
              v-model="Client.name"
              datatype="number"
              />
            </div>
            <div class="col2_block"><button class="btn">Calcul montant optimal</button></div>
          </div>
      </div>
      <div class="rowA"> 
        <div class="colSpan"><span class="span">Apport</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
      </div>
      <div class="rowA"> 
          <div class="colSpan"><span class="span">Frais de notaire</span></div>
          <div class="col-2">
            <div class="col2_block">
               <Input
              v-model="Client.name"
              datatype="number"
              />
            </div>
            <div class="col2_block"><button class="btn">Réinitialiser</button></div>
          </div>
      </div>
      <div class="rowA"> 
          <div class="colSpan"><span class="span">Frais de garentie</span></div>
          <div class="col-2">
            <div class="col2_block">
               <Input
              v-model="Client.name"
              datatype="number"
              />
            </div>
            <div class="col2_block"><button class="btn">Réinitialiser</button></div>
          </div>
      </div>
       <div class="rowA"> 
        <div class="colSpan"><span class="span">Frais de dossier de pret</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
      </div>
       <div class="rowA"> 
        <div class="colSpan"><span class="span">Frais de courtage et autres frais fixes ponctuels</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Différé d'amortissement du pret pendant la période de construction</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
      </div>
       <div class="rowA"> 
          <div class="colSpan"><span class="span">Durée du différé</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
      </div>
       <div class="rowA"> 
        <div class="colSpan"><span class="span">Montant de pret</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
              :readonly='true'
            />
          </div>
        </div>
        <div class="rowA"> 
          <div class="colSpan"><span class="span">Durée du pret</span></div>
          <div class="col-2">
            <div class="col2_block">
              <Select
              v-model="Client.name"
              :options="iteamhandicape"
              label="nom"
            />
            </div>
          </div>
      </div>
      <div class="rowA"> 
          <div class="colSpan"><span class="span">Taux du pret </span></div>
          <div class="col-2">
            <div class="col2_block">
               <Input
              v-model="Client.name"
              datatype="number"
              />
            </div>
            <div class="col2_block"><button class="btn">Réinitialiser</button></div>
          </div>
      </div>
      <div class="rowA"> 
          <div class="colSpan"><span class="span">Taux d'asurance de pret </span></div>
          <div class="col-2">
            <div class="col2_block">
               <Input
              v-model="Client.name"
              datatype="number"
              />
            </div>
            <div class="col2_block"><button class="btn">Réinitialiser</button></div>
          </div>
      </div>
       <div class="rowA"> 
        <div class="colSpan"><span class="span">Mensualité du pret</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
              :readonly='true'
            />
          </div>
        </div>
         <div class="rowA"> 
        <div class="colSpan"><span class="span">Taux d'endettement</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
              :readonly='true'
            />
          </div>
        </div>
         <div class="rowA"> 
        <div class="colSpan"><span class="span">Date de signature notaire</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="text"
            />
          </div>
        </div>
         <div class="rowA"> 
        <div class="colSpan"><span class="span">Durée d'engagement Pinel</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Durée totale d'investissement à montrer</span></div>
          <div class="col">
            <Select
              v-model="Client.name"
              :options="iteamhandicape"
              label="nom"
            />
          </div>
        </div>
         <div class="rowA"> 
        <div class="colSpan"><span class="span">Effort d'épargne estimé</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
              :readonly='true'
            />
          </div>
        </div>
        <div class="rowA">
            <div class="BoxSousTitre"><span class="sous_titre">Hypothèses de simulation</span></div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Gestion locative(en % du loyer)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Assurance loyer impayé (en % du loyer)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Revalorisation annuelle des loyers et charges locatives</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Taxe foncière (en % du loyer)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Charges mensuelles de copro (en % du loyer)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Charges annuelles de suivi comptable (en % du loyer)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span">Assurance propriétaire non occupant (cout annuel)</span></div>
          <div class="col">
            <Input
              v-model="Client.name"
              datatype="number"
            />
          </div>
        </div>
        <div class="rowA"> 
        <div class="colSpan"><span class="span"></span></div>
          <div class="col">
           <button class="btn"><fa-icon :icon="{ prefix: 'fas', iconName: 'plus'}" /> Ajouter une autre charge annuelle</button>
          </div>
        </div>
        <div class="rowA">
             <div class="arrow"> 
               <a href="#entete"><fa-icon :icon="{ prefix: 'fas', iconName: 'arrow-alt-circle-up'}" /></a>
             </div>
        </div>
     </div>
    </div>
    <div class="rowCount"><button class="btn">Enregistrer</button></div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Input from "./Input";
import Select from "./Select";
export default {
  data() {
    return {
      showCommentaire: false,
      showAnalyse: false,
      showHybothese:false,
      commentaire: null,
      //nb_enfants:this.nb_enfant,
      iteamSelect: [
        { nom: "Mr.", value: "monsieur" },
        { nom: "M.", value: "madame" },
      ],
      iteamhandicape: [
        { nom: "Non", value: false },
        { nom: "Oui", value: true },
      ],
      iteamstatut: [
        { nom: "A contacter", value: "acontacter" },
        { nom: "Oui", value: "" },
      ],
      iteamsituation:[
        { nom: "Célibatire", value: "Célibatire" },
        { nom: "Marié", value: "Marié" },
      ],
      iteamconjoint:[
        { nom: "Non", value: false },
        { nom: "Oui", value: true },  
      ],
      iteamEnfant:[
        { nom: 1, value: 1 },
        { nom: 2, value: 2 },
        { nom: 3, value: 3 },
        { nom: 4, value: 4 },
        { nom: 5, value: 5 },
       
      ],
      StatutHeberg:[
        { value: "locataire", nom: "locataire" },
        { value: "propriétaire", nom: "propriétaire" },
        { value: "hebergegratuitement", nom: "Hebérgé gratuitement" },
        { value: "logement", nom: "logement de fonction" },
      ],
      StatutPro:[
                    { value: 0, nom: "CDI cadre" },
                    { value: 1, nom: "CDI non cadre" },
                    { value: 2, nom: "CDI en période d'essai" },
                    { value: 3, nom: "CDD" },
                    { value: 4, nom: "intérim" },
                    { value: 5, nom: "intermittent du spectacl" },
                    { value: 6, nom: "Titulaire" },
                    { value: 7, nom: "Contractuel" },
                    { value: 8, nom: "Stagiaire" },
                    { value: 16, nom: "congé parental" },
                    { value: 17, nom: "Retraité" },
                    { value: 9, nom: "chef d'entreprise" },
                    { value: 10, nom: "Profession libérale" },
                    { value: 11, nom: "Artisan" },
                    { value: 12, nom: "Agriculteur" },
                    { value: 13, nom: "travailleur indépendant" },
                    { value: 14, nom: "Auto-entrepreneur" },
                    { value: 15, nom: "Commerçant" },
                    { value: 18, nom: "chercheur d'emploi" },
                    { value: 19, nom: "étudiant" },
                    { value: 20, nom: "sans profession" },
      ],
      Critere: [
        { value: "Rentabilité locative", nom: "Rentabilité locative" },
        { value: "Sécurité locative", nom: "Sécurité locative" },
        { value: "Attractivité du quartier", nom: "Attractivité du quartier" },
        { value: "Potentiel de plus-value", nom: "Potentiel de plus-value" },
        { value: "Facilité de la revente", nom: "Facilité de la revente" },  
      ],
        NB_enfants:null,
      Client: {
        iteamSelected: "madame",
        first_name: null,
        email: null,
        adresse: null,
        handicape: false,
        statut: null,
        zipCode: null,
        last_name: null,
        tel: null,
        mobile: null,
        ville: null,
        situation:null,
        conjoint:null,
        nb_enfants:[
          {
            date_naissance:'2020-11-18',
            garde:false,
            handicape:true,
          },
          {
            date_naissance:'1990-04-23',
            garde:false,
            handicape:true,
          },
        ]
      },
    };
  },
  components: {
    Input,
    Select,
  },
  methods: {
    ...mapActions(['getClient']),
    NewComment() {
      if(this.commentaire!==null && this.commentaire!==''){
        console.log("new comment", this.commentaire);
        this.commentaire = null;
      }
    },
    NewEnfant(value){
      if(value< this.Client.nb_enfants.length){
        var occ=this.Client.nb_enfants.length-value
        this.Client.nb_enfants.splice(value, occ)
      }else if(value> this.Client.nb_enfants.length){
        for(var i =this.Client.nb_enfants.length ;i<value;i++ ){
          this.Client.nb_enfants.push({
            date_naissance:null,
            garde:null,
            handicape:null,
          })
        }
        
      }
      else if(value===this.Client.nb_enfants.length){
        return
      }   
    }
  },
  mounted() {
    console.log("recupere client with id ", this.$route.params.id);
    this.getClient(this.$route.params.id);
  },
  computed:{
    ...mapGetters(['getClientToEdit']),
    nb_enfant:{
      get:function(){
        return this.Client.nb_enfants.length
      },
      set:function(nb_enfant){
        this.nb_enfants=nb_enfant
      }
    }
  }
};
</script>

<style scoped lang="scss">
.UpdateClient {
  width: 100%;
  display: inline;
  .rowCount {
    display: flex;
    width: 100%;
      .btn {
            background-color:#068596fa;
            color: white;
            border: 1px solid #068596ba;
            border-radius: 3px;
            font-size:13px;
            width: 91%;
            margin: 8px;
            margin-left: 17px;
            padding:5px;
            &:focus {
              outline: 0;
            }
            &:hover {
              border-color: #ff8c00;
              background-color: #ff8c00;
            }
          }
    .btn_update {
      text-align: left;
      margin-left: 8px;
      margin-top: 5px;
      background-color: #bfccceba;
      color: #738081;
      font-size: 25px;
      border: 1px solid #bfccceba;
      border-radius: 3px;
      height: 51px;
      width: 93%;
      outline: 0;
    }
    .desactive {
      display: none;
    }
    .BoxCommentaire {
      // margin-top: 25px;
      width: 80%;
      span {
        font-size: 20px;
        margin: 8px;
        color: #a6aeaf;
      }
      .comment {
        margin-left: 8px;
        margin-top: 8px;
        display: flex;
        textarea {
          border-radius: 5px;
          width: 55%;
          border: 1px solid #a6aeaf;
          outline: 0;
        }
        .btn {
          margin-top: 5px;
          margin-left: 8px;
          background-color: #068596ba;
          color: white;
          border: 1px solid #22a1b9;
          border-radius: 3px;
          height: 30px;
          width: 100px;
          &:focus {
            outline: 0;
          }
          &:hover {
            border-color: #ff8c00;
            background-color: #ff8c00;
          }
        }
      }
    }
    .BoxAnalyse {
      width: 95%;
      .rowA {
        display: flex;
        width: 100%;
        input[type='checkbox']{
          margin-left: 15px;
        }
        .arrow{
          width: 98%;
          text-align: right;
          font-size:30px;
         
          a{
               color :#068596fa;
          }
        }
        .colSpan{
          width: 50%;
          display: inline;
          margin-left: 15px;
          .span{
           color: hsl(188, 7%, 58%);
           font-size: 17px;
          }
        }
        .col {
          width: 50%;
          display: inline;
          .colC {
            display: flex;
            margin: 9px;
            margin-top: 0px;
            .Nomcontent {
              width: 71%;
              margin-top: 20px;
            }
            .TypeContent {
              width: 28%;
            }
          }
          .Inline {
            width: 100%;
            display: block;
            margin: 8px;
            span {
              margin: 8px;
              color: #a6aeaf;
            }
            textarea {
              margin-left: 8px;
              margin-top: 5px;
              width: 89%;
              border: 1px solid #a6aeaf;
              outline: 0;
              border-radius: 5px;
            }
          }
          .btn {
            background-color:#068596fa;
            color: white;
            border: 1px solid #068596ba;
            border-radius: 3px;
            font-size:13px;
            width: 89%;
            margin: 8px;
            margin-left: 17px;
            padding:5px;
            &:focus {
              outline: 0;
            }
            &:hover {
              border-color: #ff8c00;
              background-color: #ff8c00;
            }
          }
        }
        .col-2{
            width: 48%;
            display: flex;
            padding-left: 5px;
          .col2_block{
            width: 50%;
            .btn {
            background-color:#068596fa;
            color: white;
            border: 1px solid #068596ba;
            border-radius: 3px;
            font-size:13px;
            width: 90%;
            min-height: 65%;
            margin: 8px;
            margin-left: 15px;
            &:focus {
              outline: 0;
            }
            &:hover {
              border-color: #ff8c00;
              background-color: #ff8c00;
            }
          }
          }
        }
        .col0 {
          width: 18%;
        }
        .col1 {
          width: 25%;
        }
        .col3 {
          width: 33%;
        }
        
          .checktitre{
          padding-left:5px;
          font-size:17px;
          color:#8c999b;
        }
        .BoxSousTitre{
          margin-top:15px;
          margin-bottom:10px;
          .sous_titre{
          color:#068596ba;
          font-size: 25px;
          margin-left:10px;
        }
        }
        
      }
      .dispal_block{
        display: inline;
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .UpdateClient {
    .rowCount {
      .btn_update {
        font-size: 20px;

      }
    }
  }
}
@media screen and (max-width: 425px) {
  .UpdateClient {
    .rowCount {
      .BoxAnalyse{
        .rowA{
          display: inline;
          .col1{
            width: 100%;
          }
          .col3{
            width: 100%;
          }
          .col0{
            width: 50%;
          }
          .BoxSousTitre{
            .sous_titre{
              font-size: 21px;
            }
          }
          .col-2{
            display: inline;
            .col2_block{
              .btn{
                padding: 5px;
              }
            }
          }
          .col{
            .btn{
              margin-left:5px
            }
          }
        }
        
      }
      

    }
  }
}

</style>
